import react, { useState } from 'react'
import { Stack, TextField,  Button, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton } from '@mui/material'

import { useTranslation } from 'react-i18next';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import api from "../../api"
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../../constants';


export default function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState("")
  const navigate = useNavigate()

  const { t } = useTranslation()

  const handleSubmit = async (e) => {
    setLoading(true)
    e.preventDefault()

    try {
      const res = await api.post("/api/token/", { headers: {'Content-Type': 'application/json',}, username, password })
      localStorage.setItem(ACCESS_TOKEN, res.data.access)
      localStorage.setItem(REFRESH_TOKEN, res.data.refresh)
      const res2 = await api.get("/api/user/info/")
      localStorage.setItem('name', `${res2.data.first_name} ${res2.data.last_name}`)
      localStorage.setItem('is_staff', res2.data.is_staff)
      navigate("/")
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={3}>
        <TextField fullWidth label={t("login.username_label")} id="username" value={username} onChange={(e) => setUsername(e.target.value)} />
        <FormControl variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">{t("login.password_label")}</InputLabel>
          <OutlinedInput
            id="password"
            type={showPassword ? 'text' : 'password'}    
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>}
            label={t("login.password_label")}
          />
        </FormControl>
        <Button type="submit" variant="contained" size='large' disabled={loading}>
          {t("login.login_button")}
        </Button>
      </Stack>
    </form>
  )
}